import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import SearchByPolicyPanel from "./SearchByPolicyPanel";
import { isFlagEnabled } from "js/utilities";

export default function Forms() {
  const { t } = useTranslation();
  const { user } = useSelector((s) => s.user);

  useBreadcrumb(
    user.userId
      ? isFlagEnabled("ENABLE_SERVICE_TRACKING")
        ? [
            { name: t("CustomerForms-home-text"), url: "/policies" },
            // { name: "Services", url: "/services-claims/services" },
            { name: t("CustomerForms-forms-text"), url: "#" },
          ]
        : [
            { name: t("CustomerForms-home-text"), url: "/policies" },
            // { name: "Services and Claims", url: "/services-claims" },
            { name: t("CustomerForms-forms-text"), url: "#" },
          ]
      : [
          { name: t("CustomerForms-home-text"), url: "/" },
          { name: t("CustomerForms-forms-text"), url: "#" },
        ]
  );

  return (
    <div className="container mb-8">
      <h1>{t("Forms-title")}</h1>
      <p>{t("Forms-subtitle")}</p>
      <div className="grid grid-flow-col my-2.5 gap-2 mt-4">
        <SearchByPolicyPanel />
      </div>
    </div>
  );
}
